import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, Candy } from 'lucide-react';

export default function ArtikelHalalSuessigkeiten() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"><ArrowLeft className="w-4 h-4" />Alle Ratgeber</Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4"><Calendar className="w-4 h-4" /><span>Februar 2026</span></div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">Top 10 Halal Süßigkeiten als Eid Geschenk</h1>
          <p className="text-lg text-white/80 leading-relaxed">Die leckersten Halal-zertifizierten Süßigkeiten für das Zuckerfest – von Baklava bis Schokolade.</p>
        </div>
      </section>
      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-lg max-w-none">
          <p className="text-xl text-[#2C332E] leading-relaxed mb-8">Eid ul Fitr wird nicht umsonst "Zuckerfest" genannt – Süßigkeiten gehören zu Eid wie der Mond zum Ramadan! Aber nicht alle Süßigkeiten sind Halal. Hier findest du die 10 besten Halal-Süßigkeiten, die du bedenkenlos verschenken kannst.</p>
          
          <div className="bg-[#D4C5A9]/20 border-2 border-[#D4C5A9] rounded-2xl p-6 mb-12">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-3">⚠️ Worauf achten bei Halal-Süßigkeiten?</h3>
            <ul className="text-[#4B5563] space-y-2 text-sm">
              <li>• <strong>Gelatine:</strong> Oft aus Schwein – achte auf pflanzliche Gelatine oder Halal-Zertifikat</li>
              <li>• <strong>Alkohol:</strong> Manchmal in Aromen – bei Halal-Produkten ausgeschlossen</li>
              <li>• <strong>E-Nummern:</strong> Manche sind tierischen Ursprungs (z.B. E120, E441)</li>
              <li>• <strong>Halal-Siegel:</strong> Achte auf Zertifizierungen von anerkannten Stellen</li>
            </ul>
          </div>

          <div className="space-y-6 mb-12">
            <div className="bg-[#F5F5F0] rounded-xl p-6">
              <div className="flex items-center gap-2 mb-2"><Candy className="w-5 h-5 text-[#D4C5A9]" /><h3 className="font-medium text-[#2C332E]">1. Baklava</h3></div>
              <p className="text-sm text-[#4B5563] mb-2">Der Klassiker! Blätterteig mit Nüssen und Honig/Zuckersirup. Traditionell Halal und einfach köstlich.</p>
              <p className="text-sm text-[#4A5D4F]">Wo kaufen: Türkische Supermärkte, Bäckereien, online</p>
            </div>
            
            <div className="bg-[#F5F5F0] rounded-xl p-6">
              <div className="flex items-center gap-2 mb-2"><Candy className="w-5 h-5 text-[#D4C5A9]" /><h3 className="font-medium text-[#2C332E]">2. Turkish Delight (Lokum)</h3></div>
              <p className="text-sm text-[#4B5563] mb-2">Weiche, aromatische Würfel mit Rose, Zitrone oder Pistazie. Ein orientalischer Genuss!</p>
              <p className="text-sm text-[#4A5D4F]">Tipp: Auf Stärke statt Gelatine achten</p>
            </div>
            
            <div className="bg-[#F5F5F0] rounded-xl p-6">
              <div className="flex items-center gap-2 mb-2"><Candy className="w-5 h-5 text-[#D4C5A9]" /><h3 className="font-medium text-[#2C332E]">3. Ma'amoul</h3></div>
              <p className="text-sm text-[#4B5563] mb-2">Gefüllte Grießkekse mit Datteln oder Walnüssen – DAS traditionelle Eid-Gebäck!</p>
              <p className="text-sm text-[#4A5D4F]">Perfekt zum Selbermachen oder beim arabischen Bäcker kaufen</p>
            </div>
            
            <div className="bg-[#F5F5F0] rounded-xl p-6">
              <div className="flex items-center gap-2 mb-2"><Candy className="w-5 h-5 text-[#D4C5A9]" /><h3 className="font-medium text-[#2C332E]">4. Halal Gummibärchen</h3></div>
              <p className="text-sm text-[#4B5563] mb-2">Mit Rindergelatine oder pflanzlicher Gelatine. Beliebte Marken: Haribo Halal, Bebeto.</p>
              <p className="text-sm text-[#4A5D4F]">Im türkischen Supermarkt oder online erhältlich</p>
            </div>
            
            <div className="bg-[#F5F5F0] rounded-xl p-6">
              <div className="flex items-center gap-2 mb-2"><Candy className="w-5 h-5 text-[#D4C5A9]" /><h3 className="font-medium text-[#2C332E]">5. Belgische Schokolade</h3></div>
              <p className="text-sm text-[#4B5563] mb-2">Hochwertige Schokolade ist meist Halal. Achte auf Pralinen ohne Alkoholfüllung.</p>
              <p className="text-sm text-[#4A5D4F]">Empfehlung: Lindt, Godiva, oder lokale Chocolatiers</p>
            </div>
            
            <div className="bg-[#F5F5F0] rounded-xl p-6">
              <div className="flex items-center gap-2 mb-2"><Candy className="w-5 h-5 text-[#D4C5A9]" /><h3 className="font-medium text-[#2C332E]">6. Datteln mit Füllung</h3></div>
              <p className="text-sm text-[#4B5563] mb-2">Medjool-Datteln gefüllt mit Mandeln, Walnüssen oder überzogen mit Schokolade.</p>
              <p className="text-sm text-[#4A5D4F]">Das perfekte Eid-Geschenk mit Tradition!</p>
            </div>
            
            <div className="bg-[#F5F5F0] rounded-xl p-6">
              <div className="flex items-center gap-2 mb-2"><Candy className="w-5 h-5 text-[#D4C5A9]" /><h3 className="font-medium text-[#2C332E]">7. Halva</h3></div>
              <p className="text-sm text-[#4B5563] mb-2">Süße Sesam- oder Grießmasse – traditionell, natürlich Halal und unglaublich lecker.</p>
              <p className="text-sm text-[#4A5D4F]">Varianten: Sesam, Pistazie, Schokolade</p>
            </div>
            
            <div className="bg-[#F5F5F0] rounded-xl p-6">
              <div className="flex items-center gap-2 mb-2"><Candy className="w-5 h-5 text-[#D4C5A9]" /><h3 className="font-medium text-[#2C332E]">8. Marzipan</h3></div>
              <p className="text-sm text-[#4B5563] mb-2">Mandelmasse – meist Halal! In schönen Formen wie Früchten oder als Praline.</p>
              <p className="text-sm text-[#4A5D4F]">Lübecker Marzipan ist weltberühmt</p>
            </div>
            
            <div className="bg-[#F5F5F0] rounded-xl p-6">
              <div className="flex items-center gap-2 mb-2"><Candy className="w-5 h-5 text-[#D4C5A9]" /><h3 className="font-medium text-[#2C332E]">9. Kunafa/Knafeh</h3></div>
              <p className="text-sm text-[#4B5563] mb-2">Engelshaar-Dessert mit Käse oder Sahne und Zuckersirup. Frisch am besten!</p>
              <p className="text-sm text-[#4A5D4F]">Im arabischen Restaurant oder Bäckerei</p>
            </div>
            
            <div className="bg-[#F5F5F0] rounded-xl p-6">
              <div className="flex items-center gap-2 mb-2"><Candy className="w-5 h-5 text-[#D4C5A9]" /><h3 className="font-medium text-[#2C332E]">10. Nougat & Türkischer Honig</h3></div>
              <p className="text-sm text-[#4B5563] mb-2">Weicher Nougat mit Nüssen – süß, klebrig und unwiderstehlich!</p>
              <p className="text-sm text-[#4A5D4F]">Auf Gelatinefreiheit achten</p>
            </div>
          </div>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Geschenkbox zusammenstellen</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">Die perfekte Eid-Süßigkeiten-Box enthält:</p>
            <div className="bg-[#F5F5F0] rounded-xl p-6">
              <ul className="text-[#4B5563] space-y-2">
                <li>✓ Baklava (verschiedene Sorten)</li>
                <li>✓ Gefüllte Datteln</li>
                <li>✓ Lokum oder Ma'amoul</li>
                <li>✓ Hochwertige Schokolade</li>
                <li>✓ Halal Gummibärchen (für Kinder)</li>
              </ul>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Fazit</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">Mit diesen 10 Halal-Süßigkeiten machst du zu Eid garantiert Freude. Achte auf Zertifizierungen und Zutatenlisten – dann steht dem süßen Genuss nichts im Weg!</p>
            <p className="text-xl text-[#4A5D4F] font-medium">Eid Mubarak! 🌙</p>
          </section>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
            <ul className="space-y-2">
              <li><Link to="/ratgeber/eid-geschenkboxen" className="text-[#4A5D4F] hover:underline">→ Eid Geschenkboxen zusammenstellen</Link></li>
              <li><Link to="/ratgeber/eid-suessigkeiten-rezepte" className="text-[#4A5D4F] hover:underline">→ 15 beliebte Eid Süßigkeiten Rezepte</Link></li>
            </ul>
          </div>

          <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
            <h3 className="font-serif text-2xl font-medium text-white mb-4">Geschenke entdecken</h3>
            <Link to="/geschenke" className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors">Jetzt stöbern<Gift className="w-5 h-5" /></Link>
          </div>
        </div>
      </article>
    </main>
  );
}
